import React, { useEffect } from 'react';

import { TEXT_SESSION_EXPIRED_BODY, TEXT_SESSION_EXPIRED_BODY_NATIVE, TEXT_SESSION_EXPIRED_BUTTON, TEXT_SESSION_EXPIRED_HEADER } from '../ui-component-constants';

import RedirectUtils from '../../system-utils/redirect-utils';

import HeaderNav from '../HeaderNav';
import FullPageErrorContent from '../FullPageErrorContent';
import { setAnalyticsData } from '../../system-utils/analytics';
import { trackPageView } from '../../system-utils/hooks/useContentSquare';
import { AnalyticsDataType } from '../../system-utils/analytics/analytics';
import { setPageChange, PageTypesForNative, isNativeView } from '../../system-utils/common-utils';
import { removeApplicationFormAnswerState } from '../../system-utils/local-storage';

export const SessionExpired: React.FC = () => {
  const logBackIn = () => {
    RedirectUtils.redirectToBiBLoginPage();
  };

  useEffect(() => {
    const dataLayer: Partial<AnalyticsDataType> = {
      pageName: 'session-expired',
      globalPageName: 'business marketplace|session-expired',
    };

    setAnalyticsData(dataLayer);
    trackPageView(`/${dataLayer.pageName}`);
    setPageChange(PageTypesForNative.SESSION_EXPIRED);
    if (isNativeView()) removeApplicationFormAnswerState();
  }, []);

  if (!isNativeView()) {
    return (
      <>
        <HeaderNav showLogout={false} />
        <FullPageErrorContent pageTitle={'Session Expired'} title={TEXT_SESSION_EXPIRED_HEADER} description={TEXT_SESSION_EXPIRED_BODY} ctaText={TEXT_SESSION_EXPIRED_BUTTON} onCtaClick={logBackIn} dataTestId='nba-session-expired' />
      </>
    );
  }
  return (
    <>
      <FullPageErrorContent pageTitle={'Session Expired'} title={TEXT_SESSION_EXPIRED_HEADER} description={TEXT_SESSION_EXPIRED_BODY_NATIVE} dataTestId='nba-session-expired-native' />
    </>
  );
};
